import React from "react";
import {
  Platform,
  ScrollView,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
} from "react-native";
import { conversationStartersData } from "../data/conversationStarters.data";

type ConversationStartersListProps = {
  style?: StyleProp<ViewStyle>;
  showsVerticalScrollIndicator?: boolean;
};

/**
 * Read-only, scrollable list of conversation-starter prompts.
 * Shared by the in-call ConversationPanel and the standalone
 * ConversationStarters screen so both render the same content.
 */
export default function ConversationStartersList({
  style,
  showsVerticalScrollIndicator = true,
}: ConversationStartersListProps) {
  return (
    <ScrollView
      style={[styles.scrollView, style]}
      showsVerticalScrollIndicator={showsVerticalScrollIndicator}
    >
      {conversationStartersData.map((section, sectionIndex) => (
        <View key={sectionIndex} style={styles.section}>
          <Text style={styles.sectionTitle}>{section.title}</Text>
          {section.description ? (
            <Text style={styles.sectionDesc}>{section.description}</Text>
          ) : null}
          {section.questions.map((question, questionIndex) => (
            <Text key={questionIndex} style={styles.questionText}>
              {"•"} {question}
            </Text>
          ))}
        </View>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    ...(Platform.OS === "web"
      ? { scrollbarColor: "#3A6FB1 transparent", scrollbarWidth: "thin" }
      : null),
  },
  section: {
    marginBottom: 18,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#DD9832",
    marginBottom: 6,
    fontFamily: "LexendBold",
  },
  sectionDesc: {
    fontSize: 14,
    color: "#DD9832",
    fontFamily: "Lexend",
    marginBottom: 10,
  },
  questionText: {
    fontSize: 14,
    color: "#fff",
    lineHeight: 20,
    fontFamily: "Lexend",
    marginBottom: 6,
  },
});
